import { DashboardUserGroup } from 'domain/entity/dashboard';
import { Result } from 'domain/types';

import ReadUserGroupsClient from 'use-case/userGroups/read/readUserGroupsClient';

export type ReadUserGroupsResult = Result<DashboardUserGroup[]>;
export type ReadUserGroup = () => Promise<ReadUserGroupsResult>;

export default (readUserGroupsClient: ReadUserGroupsClient): ReadUserGroup => (): Promise<ReadUserGroupsResult> => readUserGroupsClient();
